export default __webpack_public_path__ + "static/media/828.cd1cdc84.gif";